import React from 'react';

import { formatDate, formatCurrency } from '@ajaibid/utils';
import { Badge, colors } from '@ajaibid/components';

import useEventTracker from '../../tracker';

/**
 * @returns {import('@ajaibid/components').TableColumnDefinition[]}
 */
function useMFHistoryColumns(setModal) {
  const { eventOpenMFStatus } = useEventTracker();

  const columns = [
    {
      path: 'created_date',
      name: 'Waktu',
      size: 200,
      renderCell: (ctx) => formatDate(ctx.getValue(), 'DD MMM YYYY HH:mm'),
    },
    {
      path: 'mf_name',
      name: 'Aset',
      size: 260,
      renderCell: (ctx) => (
        <div style={{ color: colors.AJAIB_BLUE_5, fontWeight: 600 }}> {ctx.getValue()} </div>
      ),
    },
    {
      path: 'type',
      name: 'Aksi',
      size: 80,
      renderCell: ({ row }) =>
        row.original?.type === 'withdraw' ? (
          <Badge type="Order" orderVariant="Sell" />
        ) : (
          <Badge
            type="Order"
            orderVariant="BUY"
            textBuy={row.original?.source === 'AUTO_ORDER' ? 'Auto Beli' : 'Beli'}
          />
        ),
    },
    {
      path: 'amount',
      name: 'Nilai Transaksi',
      size: 160,
      renderCell: (ctx) => formatCurrency(ctx.getValue(), 'IDR'),
    },
    {
      path: 'status_transaction',
      name: 'Status',
      renderCell: ({ row }) => {
        return (
          <div
            style={{ color: colors.AJAIB_BLUE_5, cursor: 'pointer' }}
            onClick={() => {
              setModal(row.original);
              eventOpenMFStatus(row.original);
            }}
          >
            {row.original?.status_transaction}
          </div>
        );
      },
    },
  ];
  return columns;
}

export default useMFHistoryColumns;
